/* SERVAL CLUB one-listing product page: any number of pairs, color, size and height per pair,
   live price from the pack rules, the unlock bar, and one add-to-cart for both sock products. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* Custom events for the Customer events pixel (Settings > Customer events). */
  function emit(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data));
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var cfg; try { cfg = JSON.parse($('script[type="application/json"]', root).textContent); } catch (e) { return; }
    var params = new URLSearchParams(location.search);
    var colors = cfg.colors, variants = cfg.variants;
    var hasLow = variants.some(function (v) { return v.h === 'low'; }), hasCrew = variants.some(function (v) { return v.h === 'crew'; });
    var H = params.get('height'); if (H !== 'low' && H !== 'crew') H = cfg.startHeight;
    if (H === 'low' && !hasLow) H = 'crew'; if (H === 'crew' && !hasCrew) H = 'low';
    var startC = parseInt(params.get('color'), 10); if (isNaN(startC)) startC = cfg.startColor; else startC -= 1;
    startC = Math.max(0, Math.min(colors.length - 1, startC));
    var n = parseInt(params.get('pack'), 10); if (!(n >= 1)) n = 3; n = Math.min(cfg.max, n);
    var rows = [];
    /* Court Club: one box product per height, always 4 pairs, billed on a Shopify Subscriptions plan */
    var club = cfg.club, mode = club && params.get('purchase') === 'club' ? 'club' : 'once', planMonths = String(cfg.clubDefaultMonths || '4');
    if (mode === 'club') { n = 4; if (!club[H]) H = club.low ? 'low' : 'crew'; }
    function box() { return club && (club[H] || club.low); }
    function plan() { var b = box(), ps = b ? b.plans : []; return ps.filter(function (x) { return String(x.months) === planMonths; })[0] || ps[0]; }
    function every(m) { return 'every ' + (m === '1' ? 'month' : m + ' months'); }

    function find(c, s, h) { var name = colors[c].name; return variants.filter(function (v) { return v.c === name && v.s === s && v.h === h; })[0]; }
    function ok(c, s, h) { var v = find(c, s, h); return v && v.available; }
    function firstOk(s, h) { for (var i = 0; i < colors.length; i++) if (ok(i, s, h)) return i; return 0; }
    /* Pack pricing mirrors the automatic discounts: Shopify applies the single best one.
       3+ pairs: d3 off the order; 4+ pairs: d4 off the order; 5+ pairs: d5 off each pair. */
    function unitOf(h) { return h === 'crew' ? cfg.unitCrew : cfg.unitLow; }
    function priceFor(hs) {
      var sub = 0, k = hs.length, off = 0;
      hs.forEach(function (h) { sub += unitOf(h); });
      if (k >= 3) off = cfg.d3;
      if (k >= 4) off = Math.max(off, cfg.d4);
      if (k >= 5) off = Math.max(off, cfg.d5 * k);
      return { sub: sub, total: sub - off };
    }
    function heights() { return rows.slice(0, n).map(function (r) { return r.h; }); }
    function plus(hs, h, k) { var a = hs.slice(); for (var i = 0; i < k; i++) a.push(h); return a; }
    function at5(h) { return unitOf(h) - cfg.d5; }
    function best5() { var t = money(at5('low')) + ' a pair'; if (hasCrew && at5('crew') !== at5('low')) t += ' (Crew ' + money(at5('crew')) + ')'; return t; }
    function imgFor(c, h) { var im = colors[c].img; return im[h] || im[h === 'low' ? 'crew' : 'low']; }

    /* gallery */
    var track = $('.sv-track', root), slides = $$('.sv-slide', track), counter = $('.sv-counter', root), thumbs = $('.sv-thumbs', root), main = $('[data-main] img', track);
    slides.forEach(function (s, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (i + 1));
      var im = $('img', s); b.innerHTML = '<img src="' + (im.currentSrc || im.src) + '" alt="" loading="lazy">';
      b.addEventListener('click', function () { go(i); });
      thumbs.appendChild(b);
    });
    function idx() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: RM ? 'auto' : 'smooth' }); }
    function sync() { var i = idx(); counter.textContent = (i + 1) + ' / ' + slides.length; $$('button', thumbs).forEach(function (b, k) { b.setAttribute('aria-current', String(k === i)); }); }
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    $('[data-prev]', root).addEventListener('click', function () { go(idx() - 1); });
    $('[data-next]', root).addEventListener('click', function () { go(idx() + 1); });
    sync();
    var lastSrc = '';
    function setGallery(c, h, jump) {
      var src = imgFor(c, h); if (!src || src === lastSrc) return; lastSrc = src;
      main.removeAttribute('srcset'); main.src = src; main.alt = cfg.title + ', ' + cfg.heights[h] + ' in ' + colors[c].name;
      var t = $('img', thumbs); if (t) t.src = src;
      var st = $('.sv-sticky img', root); if (st) st.src = src;
      if (jump && idx() !== 0) go(0);
    }

    /* price */
    var totalEl = $('.sv-total', root), wasEl = $('.sv-was', root), subEl = $('.sv-total-sub', root), addBtn = $('.sv-add', root), err = $('.sv-err', root), out = $('.sv-step-ctl output', root), shown = 0;
    function countTo(target) {
      if (RM || !shown) { totalEl.textContent = money(target); shown = target; return; }
      var from = shown, start = performance.now(), dur = 480;
      (function step(now) {
        var k = Math.min(1, (now - start) / dur), e = 1 - Math.pow(1 - k, 3);
        totalEl.textContent = money(from + (target - from) * e);
        if (k < 1) requestAnimationFrame(step); else { totalEl.textContent = money(target); shown = target; }
      })(start);
    }

    /* unlock bar: messages come from the same price math as the total */
    var gMsg = $('.sv-gifts-msg', root), gBar = $('.sv-gbar i', root), gItems = $$('.sv-gift-list li', root);
    function renderGifts() {
      var hs = heights(), last = hs[hs.length - 1], msg;
      if (n < 3) {
        var need = 3 - n, before = priceFor(plus(hs, last, need - 1)).total, after = priceFor(plus(hs, last, need)).total;
        msg = 'Add <strong>' + need + ' more pair' + (need > 1 ? 's' : '') + '</strong> for the 3-pair price and free shipping.';
        if (before === after) msg += ' The 3rd pair is free.';
      } else if (n === 3) {
        var now = priceFor(hs).total, addL = priceFor(plus(hs, 'low', 1)).total - now, addC = priceFor(plus(hs, 'crew', 1)).total - now;
        msg = '<strong>3-pair price and free shipping unlocked.</strong> Add a 4th pair for ' + money(hasLow ? addL : addC) + (hasLow && hasCrew && addC !== addL ? ' (Crew ' + money(addC) + ')' : '') + '.';
      } else if (n === 4) msg = '<strong>4th pair added.</strong> From 5 pairs, every pair is ' + best5().replace(' a pair', '') + '.';
      else msg = '<strong>Best price unlocked:</strong> ' + best5() + '.';
      gMsg.innerHTML = msg;
      gBar.style.width = Math.min(100, n / 5 * 100) + '%';
      gItems.forEach(function (li) {
        var at = +li.dataset.at, on = n >= at;
        li.classList.toggle('on', on);
        $('.g-s', li).textContent = on ? 'Unlocked' : '+' + (at - n);
      });
    }

    /* rows */
    function ensureRows() {
      while (rows.length < n) {
        var last = rows[rows.length - 1] || { c: startC, s: cfg.defaultSize, h: H };
        rows.push({ c: last.c, s: last.s, h: last.h });
      }
      rows.length = n;
    }
    function rowHTML(i) {
      var r = rows[i], html = '<div class="sv-prow" data-r="' + i + '"><b>' + (n > 1 ? 'Pair ' + (i + 1) : 'Color') + '</b><div class="sv-dots" role="radiogroup" aria-label="Pair ' + (i + 1) + ' color">';
      colors.forEach(function (c, k) {
        var off = !ok(k, r.s, r.h);
        html += '<button type="button" class="sv-dot" role="radio" style="--c:' + c.hex + '" title="' + c.name + '" aria-label="' + c.name + (off ? ', sold out' : '') + '" aria-checked="' + (r.c === k) + '" data-c="' + k + '"' + (off ? ' disabled' : '') + '></button>';
      });
      html += '</div><div class="sv-row-opts">';
      if (hasLow && hasCrew && mode !== 'club') {
        html += '<div class="sv-mini" role="radiogroup" aria-label="Pair ' + (i + 1) + ' height">';
        ['low', 'crew'].forEach(function (h) { html += '<button type="button" role="radio" data-h="' + h + '" aria-checked="' + (r.h === h) + '">' + cfg.heights[h] + '</button>'; });
        html += '</div>';
      }
      html += '<div class="sv-mini" role="radiogroup" aria-label="Pair ' + (i + 1) + ' size">';
      cfg.sizes.forEach(function (s) { html += '<button type="button" role="radio" data-s="' + s + '" aria-checked="' + (r.s === s) + '">' + s + '</button>'; });
      html += '</div></div><span class="sv-cname">' + colors[r.c].name + '</span></div>';
      return html;
    }
    function renderRows() { var box = $('.sv-pairs', root), html = ''; for (var i = 0; i < n; i++) html += rowHTML(i); box.innerHTML = html; }
    function fixRow(r) { if (!ok(r.c, r.s, r.h)) r.c = firstOk(r.s, r.h); }

    function tierPrices() {
      $$('.sv-tier[data-n]', root).forEach(function (b) {
        var t = +b.dataset.n, pr = priceFor(plus([], H, t)), big = $('.t-big', b), sm = $('.t-per', b);
        if (t === 1) { big.textContent = money(pr.total); return; }
        big.innerHTML = money(Math.floor(pr.total / t)) + '<small>/pair</small>';
        sm.textContent = t + ' pairs · ' + money(pr.total);
      });
    }
    var clubCard = $('[data-club]', root), clubPanel = $('.sv-club-panel', root), gifts = $('.sv-gifts', root);
    function renderClub() {
      var b = box(), pl = plan(), price = money(b.price), m = every(String(pl.months));
      $('[data-club-price]', clubPanel).textContent = price;
      $('[data-club-once]', clubPanel).textContent = money(priceFor(plus([], H, 4)).total);
      $('[data-club-terms]', clubPanel).textContent = 'Billed ' + price + ' ' + m + ' unless you change it. We email you 3 days before each charge. Skip, pause or cancel online anytime; email us to change how often.';
      $('[data-club-consent-text]', clubPanel).textContent = 'I agree to the Court Club terms: ' + price + ' charged ' + m + ' until I cancel.';
      var fq = $('.sv-freq', clubPanel), html = '';
      b.plans.slice().sort(function (x, y) { return x.months - y.months; }).forEach(function (x) {
        html += '<button type="button" role="radio" data-months="' + x.months + '" aria-checked="' + (String(x.months) === String(pl.months)) + '"><b>Every ' + x.months + ' months</b>' + (String(x.months) === String(cfg.clubDefaultMonths) ? '<small>Default</small>' : '') + '</button>';
      });
      fq.innerHTML = html;
      $('.t-big', clubCard).innerHTML = price + '<small>/delivery</small>';
    }
    function apply(animate) {
      if (mode === 'club') { n = 4; rows.forEach(function (r) { r.h = H; fixRow(r); }); }
      ensureRows();
      root.classList.toggle('is-club', mode === 'club');
      if (clubCard) clubCard.setAttribute('aria-checked', String(mode === 'club'));
      if (clubPanel) clubPanel.hidden = mode !== 'club';
      gifts.hidden = mode === 'club';
      if (mode === 'club') {
        var b = box(), pl = plan(), tot = b.price;
        $$('.sv-tier[data-n]', root).forEach(function (t) { t.setAttribute('aria-checked', 'false'); });
        out.textContent = 4;
        if (animate) countTo(tot); else { totalEl.textContent = money(tot); shown = tot; }
        wasEl.hidden = true;
        subEl.textContent = '4 pairs · ' + every(String(pl.months)) + ' · free shipping';
        $('span', addBtn).textContent = 'Join the Court Club · ' + money(tot);
        var sb0 = $('.sv-sticky .sv-btn span', root); if (sb0) sb0.textContent = 'Join · ' + money(tot);
        var ss0 = $('.sv-sticky .s-sub', root); if (ss0) ss0.textContent = 'Court Club · 4 pairs · ' + money(tot);
        $$('.sv-height button', root).forEach(function (b2) { b2.setAttribute('aria-checked', String(b2.dataset.height === H)); });
        renderClub(); tierPrices(); renderRows();
        setGallery(rows[0].c, rows[0].h, false);
        return;
      }
      var pr = priceFor(heights()), total = pr.total, full = pr.sub, mixed = heights().some(function (h) { return h !== rows[0].h; });
      var each = money(Math.floor(total / n)) + (mixed ? ' a pair on average' : ' a pair'), freeShip = n >= 3 || total >= cfg.freeShipAt;
      $$('.sv-tier[data-n]', root).forEach(function (b) { var t = +b.dataset.n; var on = (t === 6 && n >= 6) || (t === 3 && n >= 3 && n < 6) || (t === 1 && n < 3); b.setAttribute('aria-checked', String(on)); });
      out.textContent = n;
      $('[data-step="-1"]', root).disabled = n <= 1; $('[data-step="1"]', root).disabled = n >= cfg.max;
      if (animate) countTo(total); else { totalEl.textContent = money(total); shown = total; }
      if (total < full) { wasEl.hidden = false; $('s', wasEl).textContent = money(full); $('span', wasEl).textContent = 'You save ' + money(full - total); } else wasEl.hidden = true;
      subEl.textContent = n + (n > 1 ? ' pairs' : ' pair') + ' · ' + (n > 1 ? each : money(total)) + (freeShip ? ' · free shipping' : ' ' + cfg.shipNote);
      var label = 'Add ' + n + (n > 1 ? ' pairs' : ' pair') + ' · ' + money(total);
      $('span', addBtn).textContent = label;
      var sb = $('.sv-sticky .sv-btn span', root); if (sb) sb.textContent = 'Add · ' + money(total);
      var ss = $('.sv-sticky .s-sub', root); if (ss) ss.textContent = n + (n > 1 ? ' pairs · ' : ' pair · ') + money(total);
      $$('.sv-height button', root).forEach(function (b) { var all = rows.every(function (r) { return r.h === b.dataset.height; }); b.setAttribute('aria-checked', String(all)); });
      tierPrices(); renderRows(); renderGifts();
      setGallery(rows[0].c, rows[0].h, false);
    }
    function setN(k) { n = Math.max(1, Math.min(cfg.max, k)); apply(true); }

    $$('.sv-tier[data-n]', root).forEach(function (b) { b.addEventListener('click', function () { mode = 'once'; setN(+b.dataset.n); }); });
    $$('[data-step]', root).forEach(function (b) { b.addEventListener('click', function () { setN(n + (+b.dataset.step)); }); });
    $$('.sv-height button', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (mode === 'club' && !club[b.dataset.height]) return;
        H = b.dataset.height; rows.forEach(function (r) { r.h = H; fixRow(r); }); apply(false); setGallery(rows[0].c, rows[0].h, true);
      });
    });
    if (clubCard) clubCard.addEventListener('click', function () {
      if (mode === 'club') return;
      mode = 'club'; if (!club[H]) H = club.low ? 'low' : 'crew';
      apply(true);
      emit('club_selected', { height: H, pack_size: 4, purchase_type: 'club', frequency_months: +plan().months, value: box().price / 100, currency: cfg.currency });
    });
    if (clubPanel) clubPanel.addEventListener('click', function (e) {
      var f = e.target.closest('[data-months]'); if (!f) return;
      planMonths = f.dataset.months; apply(false);
    });
    root.addEventListener('click', function (e) {
      var row = e.target.closest('.sv-prow'); if (!row) return;
      var r = rows[+row.dataset.r], d = e.target.closest('.sv-dot'), s = e.target.closest('[data-s]'), h = e.target.closest('[data-h]');
      if (d && !d.disabled) {
        r.c = +d.dataset.c;
        $$('.sv-dot', row).forEach(function (x) { x.setAttribute('aria-checked', String(x === d)); });
        $('.sv-cname', row).textContent = colors[r.c].name;
        if (+row.dataset.r === 0) setGallery(r.c, r.h, true);
        return;
      }
      if (s) { r.s = s.dataset.s; fixRow(r); apply(false); }
      if (h) { r.h = h.dataset.h; fixRow(r); apply(false); if (+row.dataset.r === 0) setGallery(r.c, r.h, true); }
    });

    /* add to cart */
    addBtn.addEventListener('click', function () {
      if (mode === 'club') return addClub();
      var map = {}, items = [];
      for (var i = 0; i < n; i++) {
        var v = find(rows[i].c, rows[i].s, rows[i].h);
        if (!v || !v.available) { err.hidden = false; err.textContent = 'Pair ' + (i + 1) + ': that color, size and height is sold out. Pick another.'; return; }
        map[v.id] = (map[v.id] || 0) + 1;
      }
      Object.keys(map).forEach(function (id) { items.push({ id: +id, quantity: map[id] }); });
      var sling = $$('[data-addon]:checked', root);
      sling.forEach(function (cb) { items.push({ id: +cb.value, quantity: 1 }); });
      var hs = heights(), pr = priceFor(hs), info = { height: hs.every(function (h) { return h === hs[0]; }) ? hs[0] : 'mixed', pack_size: n, purchase_type: 'one_time', value: pr.total / 100, currency: cfg.currency };
      err.hidden = true; addBtn.setAttribute('aria-busy', 'true');
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
          emit('serval_add_to_cart', info);
          if (sling.length) emit('sling_added', { price: cfg.addonPrice / 100, currency: cfg.currency, placement: 'product_page' });
          location.href = cfg.cartUrl;
        })
        .catch(function (e) { addBtn.removeAttribute('aria-busy'); err.hidden = false; err.textContent = e.message + ' Please try again.'; });
    });

    function addClub() {
      var b = box(), pl = plan(), consent = $('[data-club-consent]', root), props = { Height: cfg.heights[H] }, items;
      if (!consent || !consent.checked) { err.hidden = false; err.textContent = 'Please tick the box to agree to the Court Club terms.'; if (consent) consent.focus(); return; }
      for (var i = 0; i < 4; i++) {
        var v = find(rows[i].c, rows[i].s, H);
        if (!v || !v.available) { err.hidden = false; err.textContent = 'Pair ' + (i + 1) + ': that color and size is sold out. Pick another.'; return; }
        props['Pair ' + (i + 1)] = colors[rows[i].c].name + ' · ' + rows[i].s;
      }
      props.Renews = every(String(pl.months)) + ' until you cancel';
      props._Terms = $('[data-club-terms]', root).textContent;
      props._Consent = 'Checked ' + new Date().toISOString();
      items = [{ id: b.variant, quantity: 1, selling_plan: pl.id, properties: props }];
      var sling = $$('[data-addon]:checked', root);
      sling.forEach(function (cb) { items.push({ id: +cb.value, quantity: 1 }); });
      err.hidden = true; addBtn.setAttribute('aria-busy', 'true');
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
          emit('serval_add_to_cart', { height: H, pack_size: 4, purchase_type: 'club', frequency_months: +pl.months, value: b.price / 100, currency: cfg.currency });
          if (sling.length) emit('sling_added', { price: cfg.addonPrice / 100, currency: cfg.currency, placement: 'product_page' });
          location.href = cfg.cartUrl;
        })
        .catch(function (e) { addBtn.removeAttribute('aria-busy'); err.hidden = false; err.textContent = e.message + ' Please try again.'; });
    }

    /* sticky bar once the main button scrolls away */
    var sticky = $('.sv-sticky', root);
    if (sticky) {
      new IntersectionObserver(function (es) {
        var e = es[0], past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('show', past); sticky.setAttribute('aria-hidden', String(!past));
        $('.sv-btn', sticky).tabIndex = past ? 0 : -1;
      }).observe(addBtn);
      $('.sv-btn', sticky).addEventListener('click', function () { addBtn.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' }); setTimeout(function () { addBtn.click(); }, RM ? 0 : 450); });
    }

    rows.push({ c: startC, s: cfg.defaultSize, h: H }); fixRow(rows[0]);
    apply(false);
    setGallery(rows[0].c, rows[0].h, false);
    emit('serval_view_content', { height: H, pack_size: n, purchase_type: mode === 'club' ? 'club' : 'one_time', value: priceFor(heights()).total / 100, currency: cfg.currency });
  }

  function boot(scope) { $$('[data-sv-pdp]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
